import { Grid, useMediaQuery } from "@mui/material";

import PlanCard from "./PlanCard";
import { isCurrentPlan } from "../../utils/planUtils";

export default function PlanGrid({
  plans,
  currentPlanId,
  planExpiryDate,
  onSelectPlan,
}) {
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  return (
    <Grid
      container
      spacing={isMobileView ? 1 : 3}
      sx={{
        width: "100%",
        justifyContent: "center",
        alignItems: "stretch",
        maxWidth: "1200px",
        mx: "auto",
      }}
    >
      {plans.map((plan) => (
        <PlanCard
          key={plan.id || plan.title}
          plan={plan}
          isCurrent={isCurrentPlan(plan, currentPlanId)}
          expiryDate={planExpiryDate}
          isMobile={isMobileView}
          onSelect={onSelectPlan}
        />
      ))}
    </Grid>
  );
}
